/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyValidationStatus = {
  type: 'Enum',
} as const;
